<template>
    <transition name="fade">
        <div v-if="visible" class="mask" @click="handleMaskClick" :style="customStyle">
            <div class=" mask-wrapper">
                <div class="mask-content relative" :class="{ 'mask-center': center }" @click.stop>
                    <!-- <div class="close-btn" @click="handleClose">×</div> -->
                    <slot></slot>
                </div>
                <div class="close">
                    <i class="el-icon-circle-close" style="color: #fff;" @click="handleClose"></i>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    components: {
    },
    name: 'MaskContent',
    props: {
        swidth: {
            type: Number
        },
        innerData: {
            type: Array,
            default: []
        },
        visible: {
            type: Boolean,
            default: false
        },
        maskClosable: {
            type: Boolean,
            default: true
        },
        center: {
            type: Boolean,
            default: true
        },
        backgroundColor: {
            type: String,
            default: 'rgba(0, 0, 0, 0.5)'
        },
        zIndex: {
            type: Number,
            default: 1000
        }
    },
    computed: {
        customStyle() {
            return {
                backgroundColor: this.backgroundColor,
                zIndex: this.zIndex
            }
        }
    },
    methods: {
        handleMaskClick() {
            if (this.maskClosable) {
                this.handleClose()
            }
        },
        handleClose() {
            this.$emit('update:visible', false)
            this.$emit('close')
        }
    },
}
</script>

<style scoped lang="less">
.mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .mask-wrapper {
        width: 100%;
        // height: 100%;
        position: absolute;
        top: 40%;
        left: 50%;
        transform: translate(-50%, -40%);
        // height: 70%;
        // min-width: 50%;
        // max-width: 76%;
        // max-height: 90%;
        // min-height: 60%;
    }

    .mask-content {

        box-sizing: border-box;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        margin: auto;
        padding: 20px;
        position: relative;

        width: 96%;
        // height: 96%;
        overflow: hidden;
        overflow-y: auto;

        &.mask-center {
            // position: absolute;
            // top: 50%;
            // left: 50%;
            // transform: translate(-50%, -50%);
            // margin: 0;
        }
    }

    .close {
        // position: absolute;
        // bottom: -80px;
        margin-top: 20px;
        font-size: 40px;
        // left: 0;
        // right: 0;
        text-align: center;
    }

    // .close-btn {
    //     position: absolute;
    //     top: 0;
    //     right: 5px;
    //     // width: 34px;
    //     // height: 34px;
    //     // line-height: 34px;
    //     text-align: center;
    //     cursor: pointer;
    //     font-size: 38px;
    //     color: #666;
    //     border-radius: 50%;
    //     transition: all 0.3s;
    //     z-index: 10;

    // }
}

// Transition animations
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.creative-inner-tiny {
    color: #666;
    padding: 0 5px;

    img {
        width: 100%;
        height: fit-content;
        min-height: 380px;
    }


    .title {
        font-size: 30px;
        padding-bottom: 10px;
    }

    .content {
        color: #999;
        font-size: 20px;
    }
}

// Responsive styles
@media screen and (min-width: 1024px) {
    .mask {
        .mask-content {
            width: 40%;
            // // height: 76%;
            // // margin: 10vh auto 30px;
            // padding: 30px;
            // max-width: 90%;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/MaskContent.vue